import cookie from "js-cookie";

// Experience ID is a persistent uuid stored in the user's cookies
// It enables us to serve a consistent feature flag experience from
// the user's first interaction with the site (as guest) through a
// login transition (and optionally back to guest again)

export const EXPERIENCE_ID_COOKIE_NAME = "experience_id";

export const getExperienceId = (): string | undefined => {
  if (typeof window === "undefined") return;
  return cookie.get(EXPERIENCE_ID_COOKIE_NAME);
};
